<!-- HERO -->
<section class="hero">
  <div class="hero-inner">
    <a class="hero-back" [routerLink]="['/']">
      <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
      Volver al inicio
    </a>
    <div class="hero-chip" style="margin-top:1.25rem">
      <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
      Catálogo completo de funciones
    </div>
    <h1>Todo lo que puedes hacer<br>con <span class="grad">CradleResident</span></h1>
    <p class="hero-sub">Explora cada función de la plataforma: administración, control de accesos y comunidad, en una sola app.</p>
    <div class="jump-pills">
      <a class="pill" [routerLink]="['/features']" [fragment]="'pagos'">💳 Pagos y administración</a>
      <a class="pill" [routerLink]="['/features']" [fragment]="'seguridad'">🛡️ Seguridad y accesos</a>
      <a class="pill" [routerLink]="['/features']" [fragment]="'comunidad'">🗣️ Comunidad</a>
    </div>
  </div>
</section>

<!-- PAGOS Y ADMINISTRACIÓN -->
<section class="cat-section" id="pagos">
  <div class="container">
    <div class="cat-header" appReveal>
      <div class="cat-icon" style="background:var(--lavender)">💳</div>
      <div>
        <h2>Pagos y administración</h2>
        <p>Gestión financiera y operativa de tu fraccionamiento, completamente digital.</p>
      </div>
    </div>
    <div class="cat-divider"></div>
    <div class="row g-4">

      <div class="col-md-8">
        <div class="fc fc-wide fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">💳</span>
          <h3>Control de pagos de mantenimiento</h3>
          <p>Registra y da seguimiento a las cuotas de mantenimiento de cada residente. Consulta en tiempo real quién ha pagado, quién tiene adeudos y el monto de cada transacción sin hojas de cálculo ni papeleo.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">📜</span>
          <h3>Estado de cuenta del residente</h3>
          <p>Cada residente consulta su estado de cuenta actualizado desde la app: pagos realizados, pendientes y saldo a favor en cualquier momento.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">📂</span>
          <h3>Registro de gastos con archivo digital</h3>
          <p>Documenta cada egreso de la privada con su comprobante digital adjunto. Mantén un historial ordenado y transparente de todas las salidas de dinero.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">🧾</span>
          <h3>Envío y recepción de comprobantes</h3>
          <p>Intercambia comprobantes de pago directamente desde la app. Residentes y administradores tienen acceso inmediato a sus recibos sin necesidad de impresiones.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">☁️</span>
          <h3>Almacenamiento ilimitado</h3>
          <p>Todos los comprobantes de ingresos y egresos se guardan en la nube sin límite de espacio. Accede a cualquier documento histórico en segundos.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">🧑‍💻</span>
          <h3>Gestión de usuarios</h3>
          <p>Administra los perfiles de residentes, guardias y administradores. Asigna roles y permisos personalizados según la responsabilidad de cada usuario.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">🎾</span>
          <h3>Administración de amenidades</h3>
          <p>Gestiona las áreas comunes como alberca, salón o gimnasio. Define horarios, reglas de uso y disponibilidad directamente desde el panel de administración.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">📦</span>
          <h3>Sistema de paquetería</h3>
          <p>Registra la llegada de paquetes y notifica al residente de inmediato. Lleva un control completo de entregas con confirmación de recepción.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">📕</span>
          <h3>Manejo de reportes</h3>
          <p>Genera reportes financieros y operativos de la privada. Visualiza estadísticas de pagos, gastos y actividad de la comunidad en gráficas claras.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-blue h-100" appReveal>
          <span class="fc-emoji">🔐</span>
          <h3>Consulta histórica de accesos</h3>
          <p>Consulta el historial completo de entradas y salidas de la privada. Filtra por residente, visita, fecha y tipo de acceso con facilidad.</p>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- SEGURIDAD Y CONTROL DE ACCESO -->
<section class="cat-section cat-sec-bg" id="seguridad">
  <div class="container">
    <div class="cat-header" appReveal>
      <div class="cat-icon" style="background:var(--peach)">🛡️</div>
      <div>
        <h2>Seguridad y control de acceso</h2>
        <p>Control total de quién entra y sale, con tecnología RFID, UHF y código QR.</p>
      </div>
    </div>
    <div class="cat-divider"></div>
    <div class="row g-4">

      <div class="col-md-8">
        <div class="fc fc-wide fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">🚙</span>
          <h3>Automatización de accesos para residentes</h3>
          <p>Los residentes acceden a la privada automáticamente mediante RFID, UHF o código QR. Sin detenciones ni esperas en caseta: la barrera se abre al detectar al residente y se registra el acceso de forma automática.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">🚪</span>
          <h3>Control de visitas con código QR</h3>
          <p>El residente genera un QR para autorizar a sus visitas. El guardia escanea el código y la barrera se abre solo si el acceso fue aprobado.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">🗓️</span>
          <h3>QR para visitas recurrentes con horario</h3>
          <p>Crea pases de acceso permanentes o con horario específico para visitas frecuentes como empleados domésticos. El código es válido únicamente en el rango de tiempo autorizado.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">📸</span>
          <h3>Bitácora de visitas con fotografía</h3>
          <p>Cada visita queda registrada con fotografía tomada por el guardia al momento del acceso. Consulta el historial visual completo de entradas y salidas cuando lo necesites.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">📩</span>
          <h3>Notificación push de visitas</h3>
          <p>Recibe una notificación instantánea en tu celular cuando una visita entra o sale de la privada. Mantente informado en todo momento, estés donde estés.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">📱</span>
          <h3>Apertura remota desde la app</h3>
          <p>Abre la barrera o puerta de acceso directamente desde tu smartphone, en cualquier lugar. Ideal para autorizar accesos sin necesidad de estar presente en la privada.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">📡</span>
          <h3>Lectores QR, RFID y UHF</h3>
          <p>Integra lectores de múltiples tecnologías según las necesidades de tu privada. QR para visitas, RFID para peatones y UHF de largo alcance para vehículos en movimiento.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">🚦</span>
          <h3>Panel de control para barreras</h3>
          <p>Interfaz centralizada para conectar y controlar barreras vehiculares, brazos operadores y cerraduras eléctricas. Todo el hardware de acceso, gestionado desde un solo lugar.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">📷</span>
          <h3>Conexión con cámaras IP</h3>
          <p>Integra cámaras de seguridad IP para capturar fotografías automáticas en cada acceso. Registro visual completo y sin intervención manual del guardia.</p>
        </div>
      </div>

      <div class="col-md-8">
        <div class="fc fc-wide fc-accent-peach h-100" appReveal>
          <span class="fc-emoji">🆘</span>
          <h3>Botón de pánico</h3>
          <p>En caso de emergencia, el residente activa el botón de pánico desde la app para alertar simultáneamente a todos los vecinos y guardias de la privada. Respuesta inmediata coordinada ante cualquier incidente de seguridad.</p>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- COMUNICACIÓN Y COMUNIDAD -->
<section class="cat-section" id="comunidad">
  <div class="container">
    <div class="cat-header" appReveal>
      <div class="cat-icon" style="background:var(--mint)">🗣️</div>
      <div>
        <h2>Comunicación y comunidad</h2>
        <p>Mantén a toda la comunidad conectada, informada y organizada.</p>
      </div>
    </div>
    <div class="cat-divider"></div>
    <div class="row g-4">

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">💬</span>
          <h3>Chat con vigilancia</h3>
          <p>Canal de comunicación directo entre residentes y el guardia o guardia virtual. Envía mensajes, solicitudes o reporta incidentes en tiempo real.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">📝</span>
          <h3>Publicación de anuncios</h3>
          <p>La administración publica avisos importantes para toda la comunidad con notificación push automática. Cada residente recibe el aviso al instante en su celular.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">📊</span>
          <h3>Encuestas en línea</h3>
          <p>Crea y comparte encuestas con todos los residentes para tomar decisiones colectivas. Resultados en tiempo real y de forma completamente transparente para la comunidad.</p>
        </div>
      </div>

      <div class="col-md-8">
        <div class="fc fc-wide fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">🗓️</span>
          <h3>Reservación de amenidades</h3>
          <p>Los residentes reservan áreas comunes directamente desde la app: alberca, salón de eventos, cancha, gimnasio y más. El sistema gestiona disponibilidad automáticamente y evita conflictos de horario sin necesidad de llamadas ni listas manuales.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">📩</span>
          <h3>Notificación de servicios públicos</h3>
          <p>Recibe aviso cuando servicios como gas, agua o electricidad soliciten acceso a la privada. Autoriza o rechaza la entrada directamente desde la app.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">📞</span>
          <h3>Directorio de emergencias</h3>
          <p>Accede a los números de emergencia de la privada y servicios esenciales desde la app. Disponible incluso con conexión limitada a internet.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">📘</span>
          <h3>Publicación de reglamento</h3>
          <p>Publica el reglamento interno de la privada accesible para todos desde la app. Mantén a residentes y vigilantes informados sobre las normas vigentes en todo momento.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">🥇</span>
          <h3>Logros de la administración</h3>
          <p>Comparte los avances y mejoras realizadas por la administración con toda la comunidad. Fomenta la confianza y transparencia en la gestión de la privada.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="fc fc-accent-mint h-100" appReveal>
          <span class="fc-emoji">📈</span>
          <h3>Registro de reportes</h3>
          <p>Los residentes reportan incidencias o solicitudes directamente desde la app. La administración da seguimiento y respuesta a cada reporte con trazabilidad completa.</p>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- CTA -->
<app-cta
  title="¿Listo para implementar CradleResident?"
  subtitle="Solicita una demostración gratuita y te mostramos cada función en acción."
  [showAppBadges]="false">
</app-cta>
